export default __webpack_public_path__ + "static/media/post_card1.2f3f5802.svg";